module.exports = __webpack_public_path__ + "static/media/protekt_white.0157e466.svg";